import { TrailerPlayer } from "/app/libraries/arcana/src/atoms/TrailerPlayer/index.ts"

import { COMPONENT, register } from '~/core/repository'
import { BannerRowContainerWithTrailerPortal } from './ui'

export { BannerRowContainerWithTrailerPortal } from './ui'

register(
  BannerRowContainerWithTrailerPortal,
  'BannerRowContainerWithTrailerPortal',
  COMPONENT
)

// Slot-only component for skin banners (actual player is rendered inside TrailerPlayerPortal)
register(TrailerPlayer, 'TrailerPlayerSlot', COMPONENT)
